import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Link } from 'lego-on-react';
import * as React from 'react';

import { ImageSmartCenterEditorSwitcherContainer } from '../../containers/ImageSmartCenterEditorContainer/ImageSmartCenterEditorSwitcherContainer/ImageSmartCenterEditorSwitcherContainer';
import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { BannerId } from '../../typings/banners';
import { LinkTarget } from '../../typings/common';
import { BannerViewType, PcodeRenderData } from '../../typings/pcode';
import { CanvasCreativePreviewIFrame } from '../CanvasCreativePreviewIFrame/CanvasCreativePreviewIFrame';
import { ModalDecorator } from '../ModalDecorator/ModalDecorator';
import { PcodePreview } from '../PcodePreview/PcodePreview';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';
import { StyledLink, StyledLinkTheme } from '../StyledLink/StyledLink';
import { Tab, TabList, TabPanel, Tabs, TabsSize } from '../Tabs/Tabs';

import './BannerTypesPopup.css';
import * as keyset from './BannerTypesPopup.i18n';

const i18n = i18nFactory(keyset);

export interface BannerTypesPopupProps {
    isVisible: boolean;
    data: PcodeRenderData[];
    onCancel: () => void;
    bannerId?: BannerId;
    videoUrl?: string;
}

const BLOCK = 'banner-types-popup';
const VIDEO_URL_HELP =
    'https://yandex.ru/support/direct/features/video-extension.html';

export class BannerTypesPopup extends React.Component<BannerTypesPopupProps> {
    render() {
        const {
            data = [],
            isVisible,
            bannerId,
            onCancel,
            videoUrl
        } = this.props;

        return (
            <ModalDecorator
                cls={Bem.cls(BLOCK)}
                onOutsideClick={onCancel}
                visible={isVisible}
                hasClose={true}
                scrollable={true}
                onClose={onCancel}
                fixedWidth={960}
            >
                <div className={Bem.cls(BLOCK, 'content')}>
                    <div className={Bem.cls(BLOCK, 'header')}>
                        <div className={Bem.cls(BLOCK, 'header-text')}>
                            {i18n('banner-types')}
                        </div>
                        <div className={Bem.cls(BLOCK, 'header-description')}>
                            <span>{i18n('banner-types-description')}</span>
                            <Link
                                cls={Bem.cls(BLOCK, 'info')}
                                theme="pseudo"
                                target={LinkTarget.blank}
                                url={'https://yandex.ru/support/partner2/'}
                            >
                                <Shape2
                                    cls={Bem.cls(BLOCK, 'info-icon')}
                                    icon={Shape2Icon.info}
                                    theme={Shape2Theme.default}
                                    width={15}
                                    height={15}
                                />
                            </Link>
                        </div>
                    </div>

                    <div className={Bem.cls(BLOCK, 'body')}>
                        <Tabs
                            size={TabsSize.s}
                            className={Bem.cls(BLOCK, 'tabs')}
                        >
                            <div className={Bem.cls(BLOCK, 'tabs-header')}>
                                <TabList>
                                    <Tab>{i18n('desktop-and-mobile')}</Tab>
                                    <Tab>{i18n('video')}</Tab>
                                </TabList>
                            </div>

                            <TabPanel>
                                {bannerId && (
                                    <div
                                        className={classNames(
                                            Bem.cls(
                                                BLOCK,
                                                'smart-center-switcher'
                                            ),
                                            TestBem.cls(
                                                BLOCK,
                                                'smart-center-switcher'
                                            )
                                        )}
                                    >
                                        <ImageSmartCenterEditorSwitcherContainer
                                            bannerId={bannerId}
                                        />
                                    </div>
                                )}
                                {data.map((item, index) => {
                                    const { size } = item;
                                    const sizeText = size
                                        ? `${size.width}x${size.height}`
                                        : '';

                                    return (
                                        <div
                                            key={index}
                                            className={Bem.cls(
                                                BLOCK,
                                                'preview-item'
                                            )}
                                        >
                                            <div
                                                className={Bem.cls(
                                                    BLOCK,
                                                    'preview-item-title'
                                                )}
                                            >
                                                {index + 1}. {i18n('size')}:{' '}
                                                {sizeText}
                                            </div>
                                            <PcodePreview
                                                cls={Bem.cls(
                                                    BLOCK,
                                                    'preview-item-content'
                                                )}
                                                data={item}
                                            />
                                        </div>
                                    );
                                })}
                            </TabPanel>
                            <TabPanel>
                                <div className={Bem.cls(BLOCK, 'tab-video')}>
                                    {videoUrl !== undefined &&
                                    data.length > 0 ? (
                                        <CanvasCreativePreviewIFrame
                                            previewData={data[0]}
                                            videoUrl={videoUrl}
                                            type={
                                                BannerViewType.videoAdditionPreview
                                            }
                                        />
                                    ) : (
                                        <div
                                            className={Bem.cls(
                                                BLOCK,
                                                'no-video'
                                            )}
                                        >
                                            <div
                                                className={Bem.cls(
                                                    BLOCK,
                                                    'no-video-content'
                                                )}
                                            >
                                                <div
                                                    className={Bem.cls(
                                                        BLOCK,
                                                        'no-video-text'
                                                    )}
                                                >
                                                    {i18n('no-video-text')}
                                                </div>
                                                <div
                                                    className={Bem.cls(
                                                        BLOCK,
                                                        'no-video-text'
                                                    )}
                                                >
                                                    <StyledLink
                                                        theme={
                                                            StyledLinkTheme.blue
                                                        }
                                                        target={
                                                            LinkTarget.blank
                                                        }
                                                        href={VIDEO_URL_HELP}
                                                    >
                                                        {i18n(
                                                            'more-about-video'
                                                        )}
                                                    </StyledLink>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </ModalDecorator>
        );
    }
}
